import { render } from "./DemoAgentsView.vue?vue&type=template&id=2def80ae&scoped=true"
import script from "./DemoAgentsView.vue?vue&type=script&lang=js"
export * from "./DemoAgentsView.vue?vue&type=script&lang=js"

import "./DemoAgentsView.vue?vue&type=style&index=0&id=2def80ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2def80ae"]])

export default __exports__